/**
 * UTC-first month utilities for consistent financial period boundaries.
 */

export function toDate(value: Date | string | { toDate?: () => Date } | undefined): Date | undefined {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (typeof value === 'object' && typeof value.toDate === 'function') {
    return value.toDate();
  }
  const parsed = new Date(value as string);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

/** First instant of calendar month in UTC */
export function startOfMonthUTC(date: Date): Date {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
}

export function getMonthsElapsed(startDate: Date, targetDate: Date): number {
  const start = startOfMonthUTC(startDate);
  const target = startOfMonthUTC(targetDate);
  return (
    (target.getUTCFullYear() - start.getUTCFullYear()) * 12 +
    (target.getUTCMonth() - start.getUTCMonth())
  );
}

export function isActiveInMonth(
  item: { startDate?: Date; endDate?: Date },
  targetDate: Date
): boolean {
  const month = startOfMonthUTC(targetDate).getTime();
  if (item.startDate) {
    if (month < startOfMonthUTC(item.startDate).getTime()) return false;
  }
  if (item.endDate) {
    if (month > startOfMonthUTC(item.endDate).getTime()) return false;
  }
  return true;
}

export const FAR_FUTURE = new Date(Date.UTC(2099, 11, 1));
